module.exports = __webpack_public_path__ + "static/media/associate.ecda9a4b.svg";